"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_dom_1 = require("react-dom");
// top level application entrypoint polyfill imports
require('core-js/stable');
require('regenerator-runtime/runtime');
var history_1 = require("history");
var Sentry = __importStar(require("@sentry/react"));
var tracing_1 = require("@sentry/tracing");
var RootPage_1 = __importDefault(require("./components/pages/RootPage"));
var requests_1 = require("./util/requests");
var i18n_1 = require("./i18n");
var store_1 = __importDefault(require("./store"));
var history = history_1.createHashHistory();
// If SENTRY_DNS env var is specified, init sentry.
requests_1.get('/api/sentry/').then(function (response) {
    if (response.ok) {
        response.text().then(function (sentryDns) {
            if (sentryDns) {
                Sentry.init({
                    dsn: sentryDns,
                    integrations: [
                        new tracing_1.Integrations.BrowserTracing({
                            routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
                        }),
                    ],
                    tracesSampleRate: 1.0,
                });
            }
        });
    }
});
i18n_1.i18nInit.then(function () {
    return react_dom_1.render(react_1.default.createElement(RootPage_1.default, { store: store_1.default, history: history }), document.getElementById('root'));
});
